import '../../css/navbar.css';
import NaveItems from './nva-item';

function Navbar(){
    return(
        <div className="navbar-me">
            <NaveItems/>
        </div>
    );
}

export default Navbar;